<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M6.75 15.75c0 .413.338.75.75.75h3c.412 0 .75-.337.75-.75V15h-4.5v.75ZM9 1.5a5.256 5.256 0 0 0-5.25 5.25A5.25 5.25 0 0 0 6 11.055v1.695c0 .412.338.75.75.75h4.5c.412 0 .75-.338.75-.75v-1.695a5.247 5.247 0 0 0 2.25-4.305A5.256 5.256 0 0 0 9 1.5Zm2.137 8.325-.637.45V12h-3v-1.725l-.638-.45A3.747 3.747 0 0 1 5.25 6.75C5.25 4.68 6.93 3 9 3c2.07 0 3.75 1.68 3.75 3.75 0 1.223-.6 2.37-1.613 3.075Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
